export const getDateString = dateVal => {
  const date = new Date(dateVal);
  return date.toLocaleDateString() + " op " + 
    date.toLocaleTimeString();
}


// WEBPACK FOOTER //
// ./src/utils.js